import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { ExclusivelyPublicRoute, PrivateRoute } from './public/components/General';

import Navbar from './common/components/Navbar';

import { pathNames } from './common/constants';

import { authenticatedSelector } from './common/selectors/auth';

import views, { loadWithNewHeader } from './topic';

const propTypes = {
    authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    authenticated: authenticatedSelector(state),
});

const ROUTE = {
    exclusivelyPublic: 'exclusively-public',
    public: 'public',
    private: 'private',
};

const routesOrder = [
    'login',
    'register',
    'passwordReset',
    'passwordResetPin',
    'forgotResetPassword',
    'payment',
    'changePassword',
    'newChangePassword',
    'main',
    'overview',
    'portfolio',
    'equity',
    'announcements',
    'comparative',
    'technicalScan',
    'DalalStreet',
    'home',
    'Dashboard',
    'TermsAndConditions',
    // 'fourHundredFour',
];

const privateRouteType = {
    type: ROUTE.private,
};

const publicRouteType = {
    type: ROUTE.public,
};

const exclusivelyPublicRouteType = {
    type: ROUTE.exclusivelyPublic,
    redirectTo: '/',
};

const routes = {
    login: exclusivelyPublicRouteType,
    register: exclusivelyPublicRouteType,
    passwordReset: exclusivelyPublicRouteType,
    passwordResetPin: exclusivelyPublicRouteType,
    forgotResetPassword: exclusivelyPublicRouteType,
    newChangePassword: publicRouteType,
    payment: publicRouteType,
    home: exclusivelyPublicRouteType,
    main: privateRouteType,
    overview: privateRouteType,
    portfolio: privateRouteType,
    equity: privateRouteType,
    announcements: privateRouteType,
    comparative: privateRouteType,
    changePassword: publicRouteType,
    technicalScan: privateRouteType,
    DalalStreet: privateRouteType,
    Dashboard: privateRouteType,
   TermsAndConditions: privateRouteType,
};

@withRouter
@connect(mapStateToProps)
export default class Multiplexer extends React.Component {
    static propTypes = propTypes;

    componentWillMount() {
        console.log('Mounting Multiplexer');
    }

    componentWillUnmount() {
        console.log('Unmounting Multiplexer');
    }

    getRoutes = () => (
        routesOrder.map((routeId) => {
            const view = views[routeId];
            const path = pathNames[routeId];

            if (!view) {
                console.error(`Cannot find view associated with routeID: ${routeId}`);
                return null;
            }

            const { authenticated } = this.props;

            const redirectTo = routes[routeId].redirectTo;

            switch (routes[routeId].type) {
                case ROUTE.exclusivelyPublic:
                    return (
                        <ExclusivelyPublicRoute
                            component={view}
                            key={routeId}
                            path={path}
                            authenticated={authenticated}
                            redirectLink={redirectTo}
                            exact
                        />
                    );
                case ROUTE.private:
                    return (
                        <PrivateRoute
                            component={view}
                            key={routeId}
                            path={path}
                            authenticated={authenticated}
                            redirectLink={redirectTo}
                            exact
                        />
                    );
                case ROUTE.public:
                    return (
                        <Route
                            component={view}
                            key={routeId}
                            path={path}
                            exact
                        />
                    );
                default:
                    console.error(`Invalid route type ${routes[routeId].type}`);
                    return null;
            }
        })
    );

    // if we want to add new header in the app,
    checkNextHeaderRoute = (params, array) => array.find((item) => {
        const updatedParams = params.substring(1, params.length - 1);
        return item === updatedParams;
    });

    render() {
        console.log('Rendering Multiplexer ', this.props);
        const { location: { pathname } } = this.props;

        const showNewHeader = this.checkNextHeaderRoute(pathname, loadWithNewHeader);
        if (showNewHeader) {
            return ([
                <div>
                    <Switch key="switch">
                        {this.getRoutes()}
                    </Switch>
                </div>,
            ]);
        }
        return ([
            <Navbar key="navbar" />,
            <div
                className="smtm-main-content"
                key="main"
            >
                <Switch key="switch">
                    {this.getRoutes()}
                </Switch>
            </div>,
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/Multiplexer.js